<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative r5-devices r11-devices-main {{
		sectionclass
	}}"
	style="min-height: 23em"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
		<div class="o-stack__cell">
			<h5 class="title primary-color">
				{{ sectiontitle }}
				<a
					href="javascript:void(0)"
					class="download-icon"
					*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					(click)="downloadCSV($event)"
					target="_blank"
					><i class="fa fa-download" aria-hidden="true"></i
				></a>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content r5-devices r11-devices" *ngIf="hasData">
		<div style="width: 100%; height: 100%" class="helper">
			<div class="graph-div">
				<div class="wrapper">
					<div class="devices-chart-div" *ngFor="let config of multichartconfigurations; let i = index">
						<div *ngIf="!hasData">
							<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
						</div>
						<div *ngIf="hasData" class="continer">
							<div *ngFor="let donut of donutData; let j = index">
								<app-generic-chart
									id="device-id-{{ i }}"
									[configuration]="config"
									[colorPalette]="colorPalette"
									[data]="donutData[j]"
								>
								</app-generic-chart>
								<div class="center-text">{{ donutData[j][0]?.percent }}%</div>
								<div
									class="conversions_lable_tooltip {{ donutData[j][0]?.tooltip }}"
									appTooltip
									[attr.title]="donutData[j][0]?.tooltip"
									data-size="small"
									[options]="tooltipOptions"
								>
									<div class="graph-title">{{ donutData[j][0]?.title }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="legend-area" *ngIf="!legendDisabled">
				<ul class="legend">
					<li
						class="legend_item_dev primary-color-border"
						[ngClass]="{ item_selected: legendItem.selected }"
						(click)="selectLegendItem(legendItem)"
						*ngFor="let legendItem of legend"
					>
						{{ legendItem.displayName }}
					</li>
				</ul>
			</div>
		</div>
		<div class="sem-conversion-container" *ngIf="isR9">
			<div class="sem-conversion" *ngFor="let metric of metricObject">
				<div class="conversion">
					<div class="metric-name" appTooltip [attr.title]="metric?.tooltip" [options]="tooltipOptions">
						{{ metric.name }}
					</div>
					<div class="metric-value">{{ metric.value }}</div>
				</div>
			</div>
		</div>
		<div class="sem-conversion-metrics" *ngFor="let metric of metricObject">
			<div class="conversion-metrics">
				<div class="metric-name" appTooltip [attr.title]="metric?.tooltip" [options]="tooltipOptions">
					{{ metric.name }}
				</div>
				<div class="metric-value">{{ metric.value }}</div>
			</div>
		</div>
	</div>
	<div class="no-data-container" *ngIf="!hasData">
		<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
			<div class="o-stack__cell">
				<h5 class="title primary-color">{{ sectiontitle }}</h5>
			</div>
		</div>
		<div class="map-no-data c-portlet">No Data to Display</div>
	</div>
</div>
